import React from 'react';
import { useSelector } from 'react-redux';
import { SW_UPDATE } from './type';
import Alert from './Alert';
import {Grid, CssBaseline} from '@material-ui/core';
import './App-component/App.css';
import TopHeader from './App-component/TopHeader';
import Botnavi from './App-component/Botnavi'
import PWAPrompt from 'react-ios-pwa-prompt';
import Topnavi from './App-component/Topnavi';
import Content from './App-component/Content'; 
import Cart from './App-component/Cart';
import Profile from './App-component/Profile'
import {Dialog, DialogContent, DialogContentText, DialogActions, Button} from "@material-ui/core";
import fire from './App-component/fire';
import ccyFormat from './App-component/ccyFormat';
import { CustomView, isMobileOnly } from 'react-device-detect';
import iosImage1 from './ios1.jpg';
import iosImage2 from './ios2.jpg';
import andrImage1 from './android1.jpg';
import andrImage2 from './android2.jpg';
import Geocode from "react-geocode";
import MessengerCustomerChat from 'react-messenger-customer-chat';

fire.database().ref(`WebCount`).once('value',(snapshot)=>{
  let item = Number(snapshot.val().Visit);
  if ((!(localStorage.getItem('username')) && !(localStorage.getItem('sellerUsername')))) fire.database().ref(`WebCount`).update({Visit: item+1})
})

if (localStorage.getItem('Return') === 'Yes') {
  fire.database().ref(`WebCount`).once('value',(snapshot)=>{
    let item = Number(snapshot.val().Return);
    if ((!(localStorage.getItem('username')) && !(localStorage.getItem('sellerUsername')))) fire.database().ref(`WebCount`).update({Return: item+1})
  })
}
else localStorage.setItem('Return', 'Yes')

function App() {
  //localStorage.setItem('numberOrder', 0)
  //localStorage.setItem('showGuide','')

//  if ('serviceWorker' in navigator){
  //  window.addEventListener('load', async() => {
    //  const registration = await navigator.serviceWorker.register('./firebase-messaging-sw.js',{
      //  updateViaCache: "none"
      //})
      //fire.messaging().useServiceWorker(registration)
    //})
 // }

 Geocode.setApiKey("AIzaSyCPE0_u2njCH5xFF-WectE7Tex3iLBu1rY");
 Geocode.setLanguage("en");
 Geocode.setRegion("au");
 Geocode.enableDebug();

  const isServiceWorkerUpdated = useSelector(
    state => state.serviceWorkerUpdated,
  );
  
  const serviceWorkerRegistration = useSelector(
    state => state.serviceWorkerRegistration,
  );

  const updateServiceWorker = () => {
    const registrationWaiting = serviceWorkerRegistration.waiting;

    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: 'SKIP_WAITING' });

      registrationWaiting.addEventListener('statechange', e => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }

    localStorage.setItem('isUpdatedAvailable', "No")
  };
  
  const [tab, setTab] = React.useState(0)

  function isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1 || ua.indexOf('Instagram') > -1);
  }
  
  const groupBy = keys => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = keys.map(key => obj[key]).join('');
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, []);

  const [open, setOpen] = React.useState(isFacebookApp());
  const [reachableShops, setContent] = React.useState({dummy: []})
  
  const [seller, setSeller] = React.useState({
    isSeller: false,
    sellerName: '',
    sellerInfo: [],
  })

  const [itemList,setitemList] = React.useState([])
  const [totalAmount,setAmount] = React.useState(0)
  const [cartList, setList] = React.useState([])
  const [isEmpty, setEmpty] = React.useState(true)
  const [shopList,setShop] = React.useState([])
  const [shopDescription, setDescript] = React.useState('')
  const [isCheckOut, setCheckOut] = React.useState(false)
  const subTotal = shopList.reduce(function (s, a) { return s + a.shopTotal;}, 0)
  const [delivery, setDeli] = React.useState([]);
  const [deliFee,setFee] =  React.useState(ccyFormat(0))
  const [total,setTotal] = React.useState(ccyFormat(0))
  const [discount,setDiscount] = React.useState(ccyFormat(0))
  const [inputAddress, setAddress] = React.useState(localStorage.getItem("current-address") || '')
  const [noResult, setError] = React.useState(false)
  const [computerGuide, setGuide] = React.useState(localStorage.getItem('showGuide') !== 'No')
  const [trigger, setTrigger] = React.useState(true)
 
  if (!isMobileOnly) {
  navigator.geolocation.getCurrentPosition(function(position, error) {
    if (trigger) {
      setTrigger(false)
      Geocode.fromLatLng(position.coords.latitude,position.coords.longitude).then (
        response => {
          let address = response.results[0].formatted_address;
          if (response.results[0].address_components[0].long_name === "Unnamed Road") address = response.results[1].formatted_address
          localStorage.setItem('current-address',address)
          localStorage.setItem('current-lat',position.coords.latitude)
          localStorage.setItem('current-long',position.coords.longitude)
          localStorage.setItem('current-suburb', response.results[0].address_components[2].long_name)
          setAddress(address)
          fire.database().ref('Shop').once('value', (snapshot) => {
            let items = snapshot.val();
            let newState = [];
            let destination = address
            const service = new window.google.maps.DistanceMatrixService()
            if (destination !== "") {
              for (let item in items) {
              
              let origin = items[item].Location.Address
              let reachable =  items[item].Reachable 
              if (origin) {
            
                service.getDistanceMatrix (
                {
                  origins: [origin],
                  destinations: [destination],
                  travelMode: "DRIVING",
                  avoidHighways: false,
                  avoidTolls: false,
                }, callback )
        
                function callback(response, status) {
                  if (status === "OK") {
                    let distance = response.rows[0].elements[0].distance
                    if (distance.value <= reachable) {
                      if (items[item].Delivery){
                        for (let conditions in items[item].Delivery) {
                          if (items[item].Delivery[conditions].Condition >= distance.value) {
                            items[item].KmFee = items[item].Delivery[conditions].Fee 
                            break
                          }
                        }
                      }
                      else items[item].KmFee = "N/A"
                      items[item].Distance = distance
                      let index = newState.findIndex(arg => arg.Name === items[item].Name)
                      if (index !== -1) {
                        //console.log(newState[index])
                        if (distance.value <= newState[index].Distance.value) newState[index] = items[item]
                      }
                      else newState.push(items[item])
                    }
                    setContent({dummy: newState.sort(function(a,b){return a.Distance.value - b.Distance.value})})
                    
                    localStorage.setItem('initial_reachable', JSON.stringify(newState))
                  } 
                  else console.log("Error")
                }
              }
            }
          }
            });
        },
        error => {
          console.error(error);
          localStorage.setItem('current-address',"")
          localStorage.setItem('current-lat', -34.922851);
          localStorage.setItem('current-long', 138.60232);
          localStorage.setItem('current-suburb', 'Adelaide');  
        }
      )
      }
    });
  }

  const searchAddress = () => event => {
    event.preventDefault();
    
    fire.database().ref('Shop').once('value', (snapshot) => {
      let items = snapshot.val();
      let maxKey = 0;
      if (items.length >= 1) maxKey = items.length- 1;
      let newState = [];
      let destination = localStorage.getItem('current-address')
      const service = new window.google.maps.DistanceMatrixService()
      if (destination !== "") for (let item in items) {
          let origin = items[item].Location.Address
          let reachable =  items[item].Reachable 
          if (origin) { 
            service.getDistanceMatrix (
            {
              origins: [origin],
              destinations: [destination],
              travelMode: "DRIVING",
              avoidHighways: false,
              avoidTolls: false,
            }, callback )
  
          function callback(response, status) {
            if (status === "OK") {
              let distance = response.rows[0].elements[0].distance
              if (distance.value <= reachable) {
                if (items[item].Delivery){
                  for (let conditions in items[item].Delivery) {
                    if (items[item].Delivery[conditions].Condition >= distance.value) {
                      items[item].KmFee = items[item].Delivery[conditions].Fee 
                      break
                    }
                  }
                }
                else items[item].KmFee = "N/A"
                
                items[item].Distance = distance
                let index = newState.findIndex(arg => arg.Name === items[item].Name)
                if (index !== -1) {
                  if (distance.value <= newState[index].Distance.value) newState[index] = items[item]
                }
                else newState.push(items[item])
              }
                setContent({dummy: newState.sort(function(a,b){return a.Distance.value - b.Distance.value})})
                if (Number(item) === maxKey && newState.length === 0) setError(true)
                localStorage.setItem('initial_reachable', JSON.stringify(newState))
            } 
            else console.log("Error")
          }
        }
      }
      });
  }

  const onSellerClick = (reachableShop) => event => {
      event.preventDefault();
      const items = reachableShop["Menu"]
      let newState = [];
      for (let item in items) {
        if (items[item]) {
          newState.push({
            Name: items[item].Name,
            Price: items[item].Price,
            Available: items[item].Available,
            Description: items[item].Description,
            Address:  reachableShop.Location.Address,
            AvailableDay: reachableShop.AvailableDay,
            Contact: reachableShop.Contact,
            Time: reachableShop.Time,
            Method: reachableShop.Method,
            KmFee: reachableShop.KmFee,
            Size: items[item].Size,
            Extra: items[item].Option,
            ImageLink: items[item].ImageLink,
            Key: items[item].ID
          });
        }
      }
      setSeller({
          isSeller: true,
          sellerName: reachableShop.Name,
          sellerInfo: newState
        });
      
      setDescript(reachableShop.Description)
    }

   const handleExpand = (arg) => event => {
     event.preventDefault();
     if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
     setSeller({...seller, ['isSeller']: arg})
   }

  const updateList = (item, sizeFee, extraFee, amount, shop) => {
    
    let previousState = shopList;

    let itemName = item.Name;
    if (sizeFee.Type) itemName = itemName + ` (${sizeFee.Type})`  
    if (extraFee.Description) itemName = itemName + extraFee.Description
    
    let sizeAdd = 0
    if (sizeFee) sizeAdd = Number(sizeFee.Value)

    let extraAdd = 0
    if (extraFee) extraAdd = Number(extraFee.Value)

    let index = itemList.findIndex(arg => arg.Name === itemName && arg.Seller === shop)
    let shopIndex = previousState.findIndex(arg => arg.Seller === shop)
    const sellerListIndex = reachableShops.dummy.findIndex(arg => arg.Name === shop)
    const sellerID = (reachableShops.dummy.find(arg => arg.Name === shop)).ShopKey
    
    if (shopIndex === -1) {
      let newState = [];
      
      for (let element in item.Method){
        if (element === 'Pick-up') newState.push({
          Collect: element,
          Description: item.Method[element].Description,
          value: item.Method[element].Value,
          Promo: 0
        });
        else { 
          let kmFee = item.KmFee
          if(item.KmFee !== "N/A") newState.push({
            Collect: element,
            Description: 'Delivery: $' + kmFee,
            value: kmFee,
            Promo: 0
          });

        }
      }

      previousState.push({Seller: shop, Address: item.Address, Contact: item.Contact, Distance: reachableShops.dummy[sellerListIndex].Distance.value, Promo: 0, shopTotal: 0, Method: newState.reverse(), AvailableDay: item.AvailableDay, AvailableTime: item.Time})
    }
    if (index === -1 && (item)) 
    { 
      itemList.push({
        Name: itemName,
        Size: sizeFee,
        Extra: extraFee,
        Available: item.Available,
        ImageLink: item.ImageLink,
        Price: Number(item.Price) + sizeAdd + extraAdd,
        Total: amount * (Number(item.Price) + sizeAdd + extraAdd),
        Amount: amount,
        Seller: shop,
        ItemKey: item.Key,
        SellerID: sellerID
    })
    }
    else if (itemList[index])
    { let i = itemList[index].Amount + amount;
      if (i > Number(itemList[index].Available)) i = Number(itemList[index].Available)
      itemList[index].Amount = i
      const total = i*(Number(itemList[index].Price));
      itemList[index].Total = total;
    }
    setAmount(itemList.reduce(function (s, a) { return s + a.Amount;}, 0))
    const groupbySeller = groupBy(['Seller']);
    const listbySeller = groupbySeller(itemList); 

    for (let element in listbySeller) {
      const sumTotal = listbySeller[element].reduce(function (s, a) { return s + a.Total;}, 0);
      const sellerIndex = previousState.findIndex(arg => arg.Seller === element);
      if (previousState[sellerIndex]) previousState[sellerIndex].shopTotal = sumTotal;
    } 

    setShop(previousState)
    setList(listbySeller)
    setEmpty(false)
  }

  const addItem = (index, name) => event => {
      event.preventDefault();
      
      const itemIndex = itemList.findIndex(arg => (arg.Name === name && arg.Seller === index ))
      const i = itemList[itemIndex].Amount + 1
      if (i <= itemList[itemIndex].Available) {
        itemList[itemIndex].Amount = i
        const total = i*(itemList[itemIndex].Price);
        itemList[itemIndex].Total = total;
        setAmount(itemList.reduce(function (s, a) { return s + a.Amount;}, 0));
        const groupbySeller = groupBy(['Seller','Suburb']);
        const listbySeller = groupbySeller(itemList); 
        const sellerIndex = shopList.findIndex(arg => arg.Seller === index )
        if (shopList[sellerIndex]) shopList[sellerIndex].shopTotal = shopList[sellerIndex].shopTotal + itemList[itemIndex].Price
        setList(listbySeller)
      }
  }

  const minusItem = (index, name) => event => {
    event.preventDefault();

    const itemIndex = itemList.findIndex(arg => (arg.Name === name && arg.Seller === index))
    let i = itemList[itemIndex].Amount - 1
    if (i >= 1) {
      itemList[itemIndex].Amount = i
      const total = i*(itemList[itemIndex].Price);
      itemList[itemIndex].Total = total;
      setAmount(itemList.reduce(function (s, a) { return s + a.Amount;}, 0));
      const groupbySeller = groupBy(['Seller','Suburb']);
      const listbySeller = groupbySeller(itemList); 
      const sellerIndex = shopList.findIndex(arg => arg.Seller === index)
      if (shopList[sellerIndex]) shopList[sellerIndex].shopTotal = shopList[sellerIndex].shopTotal - itemList[itemIndex].Price
      setList(listbySeller)
    }
  }

  const removeItem = (shop, itemName) => event => {
    event.preventDefault();
    
    const itemIndex = itemList.findIndex(arg => (arg.Name === itemName && arg.Seller === shop ))

    if (cartList[shop].length === 1) {
      const shopIndex = shopList.findIndex(arg => arg.Seller === shop)
      shopList.splice(shopIndex,1)
    }
    itemList.splice(itemIndex,1)
    setAmount(itemList.reduce(function (s, a) { return s + a.Amount;}, 0))
    if (itemList.length === 0) 
    { 
      setEmpty(true)
    }
    else {
    const groupbySeller = groupBy(['Seller','Suburb']);
    const listbySeller = groupbySeller(itemList);
    
    for (let item in listbySeller) {
      const sumTotal = listbySeller[item].reduce(function (s, a) { return s + a.Total;}, 0)
      const sellerIndex = shopList.findIndex(arg => arg.Seller === item)
      if (shopList[sellerIndex]) shopList[sellerIndex].shopTotal = sumTotal
    }
    setList(listbySeller)

    var deliIndex = delivery.findIndex(arg => arg.name === shop)
    if (deliIndex !== -1) delivery.splice(deliIndex,1)
    const totalDeli = delivery.reduce(function (s, a) { return Number(s) + Number(a.fee);}, 0)
    const totalFee = subTotal + totalDeli - discount
    setFee(ccyFormat(totalDeli))
    setTotal(ccyFormat(totalFee))
  }}

  const deliOptionChange = (name) => event => {
        event.preventDefault();
        setDiscount(ccyFormat(0))
        const value = event.currentTarget.value;
        const index = delivery.findIndex(arg => arg.name === name);
        const indexShopList = shopList.findIndex(arg => arg.Seller === name);
        const indexMethod = shopList[indexShopList]['Method'].findIndex(arg => Number(arg.value) === Number(value))
        const descript = shopList[indexShopList]['Method'][indexMethod].Description
        const collect = shopList[indexShopList]['Method'][indexMethod].Collect
        delivery[index].fee = value 
        delivery[index].description= descript
        delivery[index].collect= collect
        const totalDeli = delivery.reduce(function (s, a) { return Number(s) + Number(a.fee);}, 0)
        const totalFee = subTotal + totalDeli
        setFee(ccyFormat(totalDeli))
        setTotal(ccyFormat(totalFee))
  }

  const applyPromo = (arg) => {
    setShop(arg)
    console.log(localStorage.getItem('BimBimPromotion'))
    let totalDiscount = arg.reduce(function (s, a) { return Number(s) + Number(a.Promo);}, 0) + Number(localStorage.getItem('BimBimPromotion'))
    setDiscount(ccyFormat(totalDiscount))
    let totalFee = subTotal + Number(deliFee) - Number(totalDiscount);
    if(totalFee <= 0) totalFee = 0
    setTotal(ccyFormat(totalFee))
  }

  const handleClose = () => {
    setOpen(false);
  };

  const CheckOut = (value) => event => {
    event.preventDefault();
    setCheckOut(value);
    let newState = [];
    let prevShops = shopList;
    
    for (let items in shopList){
      newState.push({
        collect: shopList[items]['Method'][0].Collect,
        name: shopList[items].Seller,
        address: shopList[items].Address,
        fee: shopList[items]['Method'][0].value,
        description: shopList[items]['Method'][0].Description
      })

      prevShops[items].Promo = 0
    };
 
    localStorage.setItem('BimBimPromotion', 0)
    setShop(prevShops)
    setDeli(newState)
    setFee(ccyFormat(0))
    setDiscount(ccyFormat(0))
    setTotal(ccyFormat(subTotal))
  }

  const onFinish = () => {
    setTab(2)
    localStorage.setItem('BimBimPromotion', 0)
    setitemList([])
    setList([])
    setShop([])
    setAmount(0)
    setEmpty(true)
    setCheckOut(false)
    setDeli([])
    setFee(ccyFormat(0))
    setDiscount(ccyFormat(0))
    setTotal(ccyFormat(0))
  }

  const handleCloseGuide = (arg) => event => {
    event.preventDefault();
    if (arg === 'OK') setGuide(false)
    if (arg === 'Dont') {
      localStorage.setItem('showGuide', 'No')
      setGuide(false)
    }
  }
  
  
  function renderView() {

    switch(tab) {
      case 0:
        return (
          <div>

            <TopHeader cartEmpty = {isEmpty} returnSeller = {searchAddress} address = {inputAddress} getAddress= {setAddress} removeContent = {setContent}/> 
            <Topnavi /> 
            <Content reachableDatas={reachableShops.dummy} stateSeller = {!seller.isSeller} sellerName ={seller.sellerName} sellerInfo = {seller.sellerInfo} sellerDetail = {shopDescription} handleChange = {onSellerClick} handleExpandClick= {handleExpand} getList = {updateList}/>
            <CustomView condition = {(!reachableShops.dummy) || (reachableShops.dummy).length === 0}>
              <MessengerCustomerChat
                pageId="107217534070143"
                appId="614327612816090"
              />
            </CustomView>
          </div>
      );

      case 1: 
        return ( 
      <div>
        <TopHeader cartEmpty = {isEmpty} returnSeller = {searchAddress} address = {inputAddress} getAddress= {setAddress} removeContent = {setContent}/> 
        <Cart cartList = {cartList} cartEmpty = {isEmpty} shopList = {shopList} onAdd={addItem} onMinus={minusItem} onRemove= {removeItem} handleChange = {deliOptionChange} isCheckOut = {isCheckOut} checkOut = {CheckOut} subTotal={subTotal} delivery={delivery} deliFee={deliFee} total ={total} applyPromo = {applyPromo} discount = {discount} onFinish = {onFinish}/> 
      </div>
      );
      
      case 2: 
          return(<Profile />  );

      default: 
        return new Error ("This View doesn't exist");
    }
  }
  

  return (
    <div className = 'App'> 
    {isServiceWorkerUpdated && (
          <Alert
            text="New version available. Click to update"
            buttonText="Update"
            type={SW_UPDATE}
            onClick={updateServiceWorker}
          />
        )}
      <Grid container direction = 'column'>
        {renderView()}
        <Botnavi value = {tab} onChange = {setTab} cartEmpty = {isEmpty} onCheckOut= {CheckOut} numberCart={totalAmount}/>  
      </Grid>
      <PWAPrompt open = {!isFacebookApp()} promptOnVisit={1} timesToShow={5} copyClosePrompt="Close" permanentlyHideOnDismiss={false}/>
      <Dialog
        open = {open}
        onclose ={handleClose}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span>Facebook and Instagram browsers are not fully supported. Use Google Chrome or Safari for full feature</span>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <span>Bạn đang mở BimBim bằng Facebook/ Instagram, một số tính năng có thể không được hỗ trợ. Mở BimBim bằng Safari hay Google Chrome để có được trải nghiệm tốt nhất</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open = {noResult}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span>Không người bán nào được tìm thấy. Kiểm tra địa chỉ và tìm kiếm lại hoặc liên hệ để được hỗ trợ</span>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <span>Could not find any sellers to your location. Please check your address and search again or contact us</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setError(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <CustomView condition = {(!isMobileOnly && !isFacebookApp())}>
          <Dialog open = {computerGuide}>
          <DialogContent>
          <DialogContentText id="alert-dialog-description">
              <span>BimBim is a web application. You can add BimBim app to your iOS/Android mobile homescreen by following the instructions</span>
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
              <span>BimBim là một ứng dụng web. Bạn có thể cài đặt BimBim về điện thoại iOS hay Android bằng hướng dẫn bên dưới</span>
          </DialogContentText>
          <DialogContent style = {{flexDirection: 'row', display: 'flex', justifyContent: 'center'}}> 
              <img  className = 'guideImage' src={iosImage1} alt="ios1"  />
              <img  className = 'guideImage' src={iosImage2} alt="ios2"  />
          </DialogContent>
          <DialogContent style = {{flexDirection: 'row', display: 'flex', justifyContent: 'center'}}> 
              <img  className = 'guideImage' src={andrImage1} alt="android1"  />
              <img  className = 'guideImage' src={andrImage2} alt="android2"  />
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseGuide('OK')} color="primary">
            OK
          </Button>
          <Button onClick={handleCloseGuide('Dont')} color="primary">
            Don't show again
          </Button>
        </DialogActions>
          </Dialog>
      </CustomView>
      <CssBaseline/>
    </div>
  );
}

export default App;